import CryptoJS from 'crypto-js';

const Decrypt = (encryptedData) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_DECRYPT_KEY, { 'iv': process.env.REACT_APP_DECRYPT_IV });
  return (decrypted.toString(CryptoJS.enc.Utf8)

  );
}
export default Decrypt;